const url = window.location.href
const { origin } = new URL(url)
let customerWebConfigURL =
    origin === process.env.REACT_APP_SSO_REDIRECT_URL_PUB
        ? process.env.REACT_APP_SEVEN_NOW_CORE_API_URL_PUB
        : process.env.REACT_APP_SEVEN_NOW_CORE_API_URL

export const customerWebConfigurationUrl = `${customerWebConfigURL}/content/configuration`
